import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import { StudentDto } from '../../interfaces/student_dto';
import { ColorService } from 'src/app/shared/services/color.service';
import { IonicModule } from '@ionic/angular';
import { NgOptimizedImage } from '@angular/common';
@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    imports: [IonicModule, NgOptimizedImage],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarComponent {
  readonly student = input<StudentDto>();

  constructor(private colorService: ColorService) { }

  getColor(student: StudentDto) {
    if (student?.forename) {
      return this.colorService.getColor(student.forename);
    }
  }
}
